import { render } from "./NewBucket.vue?vue&type=template&id=5f46034a"
import script from "./NewBucket.vue?vue&type=script&lang=js"
export * from "./NewBucket.vue?vue&type=script&lang=js"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__